import { render, staticRenderFns } from "./AddBoothModal.vue?vue&type=template&id=06c015fe&scoped=true"
import script from "./AddBoothModal.vue?vue&type=script&lang=ts"
export * from "./AddBoothModal.vue?vue&type=script&lang=ts"
import style0 from "./AddBoothModal.vue?vue&type=style&index=0&id=06c015fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c015fe",
  null
  
)

export default component.exports